// extracted by mini-css-extract-plugin
export var content = "_ns-1";
export var noScroll = "_ns-3";
export var paper = "_ns-0";
export var scrollable = "_ns-2";